import { render } from "./EditModal.vue?vue&type=template&id=e63ab6f8&scoped=true"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"

import "./EditModal.vue?vue&type=style&index=0&id=e63ab6f8&lang=less&scoped=true"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e63ab6f8"]])

export default __exports__